// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mediaRequestOutletEntity from './entities/media-request-outlet.json';
import mediaRequestOutletMenu from '../pages/media-request-outlet/menu.json';
import mediaRequestOutletFullForm from '../pages/media-request-outlet/forms/full.json';
import mediaRequestOutletContextForm from '../pages/media-request-outlet/forms/context.json';
import mediaRequestOutletMiniForm from '../pages/media-request-outlet/forms/mini.json';
import mediaRequestOutletLookupForm from '../pages/media-request-outlet/forms/lookup.json';
import mediaRequestOutletTableView from '../pages/media-request-outlet/views/table.json';
import mediaRequestOutletCardsView from '../pages/media-request-outlet/views/cards.json';
import mediaRequestOutletDashboardView from '../pages/media-request-outlet/views/dashboard.json';

/** Тип запису «Видання» зі сторінками пакета: меню, форми та подання з pages/media-request-outlet/. */
export const mediaRequestOutletDefinition: IRecordTypeDefinition = {
  ...mediaRequestOutletEntity,
  views: assembleViewSet({
      table: mediaRequestOutletTableView,
      cards: mediaRequestOutletCardsView,
      dashboard: mediaRequestOutletDashboardView,
  }),
  form: mediaRequestOutletFullForm,
  forms: { full: mediaRequestOutletFullForm, context: mediaRequestOutletContextForm, mini: mediaRequestOutletMiniForm, lookup: mediaRequestOutletLookupForm },
  menu: mediaRequestOutletMenu,
} as IRecordTypeDefinition;
